/*@jsxRuntime automatic*/
/*@jsxImportSource react*/
import {useMDXComponents as _provideComponents} from "nextra/mdx";
const title = "Terraformplan";
const frontMatter = {};
import {Alert} from '@/components';
export function useTOC(props) {
  return [];
}
function MDXLayout(props) {
  const _components = {
    a: "a",
    code: "code",
    p: "p",
    ..._provideComponents(),
    ...props.components
  };
  return <Alert severity="info"><_components.p>{"When you run "}<_components.code>{"terraform plan"}</_components.code>{" to generate an execution plan, Chronosphere automatically\ntests configurations that include notification policies by submitting them as dry runs.\nFor details, see the\n"}<_components.a href="/tooling/infrastructure/terraform#validate-plans-with-dry-runs">{"Terraform provider"}</_components.a>{"\ndocumentation."}</_components.p></Alert>;
}

export default MDXLayout